/* eslint-disable @typescript-eslint/no-explicit-any */
import BlogCard from '@/components/BlogList/BlogCard'
import CarrouselArrowIconMiddle from '@/components/Icon/CarrouselArrowIconMiddle'
import PostBreadcrumb from '@/components/PostBreadcrumb'
import { BannerType } from '@/constants'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type { BannerList, Post, PostResponse } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBannerSSR,
  getBottomMenu,
  getConfigSSR,
  getFeaturePost,
  getHeaderMenu,
  getKeyword,
  getPostCategory,
  getPostFilterCategory,
  getSaleRegion,
} from '@/utils/endpoint'
import { getCookies } from 'cookies-next'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
type ListBlogProps = {
  postCategory: Post[]
  featurePost: Post[]
  postFilterByCat: {
    item: Post
    data: PostResponse
  }[]
  banner: BannerList[]
}

const ListBlog = ({
  featurePost,
  postCategory,
  postFilterByCat,
  banner,
}: ListBlogProps) => {
  const router = useRouter()
  const bannerBlog = useMemo(() => {
    return banner.filter(banner => {
      return banner.type === BannerType.BLOG && banner.status === 1
    })
  }, [banner])
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    variableWidth: false,
    nextArrow: <CarrouselArrowIconMiddle type='next' />,
    prevArrow: <CarrouselArrowIconMiddle type='prev' />,
  }
  return (
    <Main
      meta={
        <Meta
          title={'Thông tin hữu ích'}
          description={'Thông tin hữu ích'}
          noFollow={false}
          noIndex={false}
          canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          mobileAlternate={{
            media: 'only screen and (max-width:991px))',
            href:
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
              '',
          }}
        />
      }
    >
      <PostBreadcrumb
        breadcrumbs={postCategory}
        title='Tin tức'
        banner={bannerBlog}
      />
      <section className='postList mt-5 grid min-h-[500px] grid-cols-3 gap-2 pb-10'>
        <div className='content-wrapper col-span-3'>
          {featurePost && featurePost.length > 0 && (
            <div className='featurePost mb-4'>
              <div className='grid grid-cols-4 gap-[20px]'>
                <div className='col-span-1'>
                  <div className='flex flex-col'>
                    <div className='item grid grid-cols-1 gap-[20px]'>
                      {featurePost?.slice(0, 5).map((e: Post, index) => (
                        <BlogCard
                          key={index}
                          post={e}
                          imageWidth={70}
                          imageHeight={70}
                          type={3}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div className='item col-span-2'>
                  {featurePost && featurePost[0] && (
                    <BlogCard
                      post={featurePost[0]}
                      featurePost={featurePost}
                      type={1}
                    />
                  )}
                </div>
                <div className='item col-span-1'>
                  {featurePost?.slice(0, 2).map((e: Post, index) => (
                    <BlogCard
                      key={index}
                      post={e}
                      imageWidth={100}
                      imageHeight={12}
                      type={1}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {featurePost?.length > 0 && (
            <div className='featurePost mb-4'>
              <div className='grid grid-cols-4 gap-[20px]'>
                <div className='col-span-3'>
                  <div className='rounded-lg bg-primary px-2 py-5'>
                    <h2 className='mb-4 text-xl font-bold text-white'>
                      Tin tức nổi bật
                    </h2>
                    <Slider {...settings}>
                      {featurePost?.map((e: Post, index) => (
                        <div key={index} className='px-2'>
                          <BlogCard
                            post={e}
                            imageWidth={100}
                            imageHeight={12}
                            type={5}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>

                <div className='item col-span-1'>
                  <div className='flex h-full flex-col'>
                    {featurePost?.slice(0, 2).map((e: Post, index) => (
                      <div className='flex-1' key={index}>
                        <BlogCard
                          post={e}
                          imageWidth={100}
                          imageHeight={12}
                          type={4}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {postFilterByCat &&
            postFilterByCat?.map((post, id) => {
              if (post?.data?.data && post?.data?.data?.length > 0) {
                return (
                  <div className='subCate mb-4' key={id}>
                    <div className='mb-2 flex items-center justify-between'>
                      <h2 className='text-2xl font-bold text-dark-400'>
                        {getTranslate(post?.item?.name)}
                      </h2>
                      <Link
                        href={
                          '/post/' + getTranslate(post?.item?.slugs?.value) ||
                          ''
                        }
                        className='mb-1 flex h-10 w-[200px] items-end justify-end text-primary'
                      >
                        Xem tất cả
                      </Link>
                    </div>
                    <div
                      className={`mb-3 grid ${
                        post?.data?.data?.length <= 3
                          ? `grid-cols-${post.data.data.length}`
                          : 'grid-cols-4'
                      } gap-[20px]`}
                    >
                      {post?.data?.data?.length >= 4 &&
                        post?.data?.data
                          ?.slice(0, 4)
                          .map((e: Post, i: number) => (
                            <BlogCard post={e} key={i} type={6} />
                          ))}
                    </div>
                    <div className='mb-3 grid grid-cols-3 gap-[20px]'>
                      {post?.data?.data.map((e: Post, index: number) => (
                        <BlogCard
                          key={index}
                          post={e}
                          imageWidth={70}
                          imageHeight={70}
                          type={3}
                        />
                      ))}
                    </div>
                  </div>
                )
              }
            })}
        </div>
      </section>
    </Main>
  )
}

export default ListBlog

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const [
    bottomMenu,
    globalHeaderMenu,
    keywords,
    featurePost,
    postCategory,
    postFilterByCat,
    banner,
    regions,
    systemConfig,
  ] = await Promise.all([
    getBottomMenu(),
    getHeaderMenu(),
    getKeyword(),
    getFeaturePost(),
    getPostCategory(),
    getPostFilterCategory(),
    getBannerSSR(),
    getSaleRegion(),
    getConfigSSR(),
  ])

  return {
    props: {
      bottomMenu,
      globalHeaderMenu,
      keywords,
      featurePost,
      postCategory,
      postFilterByCat,
      banner,
      language,
      messages,
      regions,
      systemConfig,
      token: token || null,
    },
  }
}
